import { render, staticRenderFns } from "./ProductRequests.vue?vue&type=template&id=d5f09204&"
import script from "./ProductRequests.vue?vue&type=script&lang=js&"
export * from "./ProductRequests.vue?vue&type=script&lang=js&"
import style0 from "./ProductRequests.vue?vue&type=style&index=0&id=d5f09204&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports